// Auto-generated cornerstone translation for es.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T13:33:32.541421+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "App gestión caballos: la mejor opción para 2026 | EquiSight",
      description: "Compara apps de gestión equina para propietarios, cuadras y criaderos. Descubre por qué EquiSight es la app completa para tu caballo.",
      keywords: [
        "app gestión caballos",
        "app gestión cuadra",
        "app diario de caballos",
        "app para gestionar varios caballos",
        "app seguimiento gestación yegua",
        "app criadero caballos",
        "mejor app gestión caballos",
      ],
    },
    hero: {
      eyebrow: "Guía de selección · software gestión equina",
      breadcrumbLabel: "App gestión caballos",
      title: "App de gestión de caballos: la guía completa para propietarios, cuadras y criaderos.",
      intro: "No es una simple lista de funciones — es una comparativa honesta, una guía de selección y un análisis de lo que una app de gestión equina realmente debe ofrecer en 2026. Para un solo caballo, para toda una cuadra o para tu criadero.",
      pills: [
        {
          icon: "Users",
          label: "Para propietarios",
        },
        {
          icon: "Building2",
          label: "Para cuadras",
        },
        {
          icon: "Baby",
          label: "Para criaderos",
        },
        {
          icon: "Share2",
          label: "Para equipos",
        },
      ],
      ctas: [
        {
          label: "Empieza gratis con 1 caballo",
          href: "#start",
          primary: true,
        },
        {
          label: "Ver tabla comparativa",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Por qué una app de gestión de caballos es cada vez más necesaria.",
      lead: "En la práctica, la gestión equina está fragmentada: WhatsApp, agenda, Excel, fotos en el móvil, un pasaporte en papel, facturas sueltas y acuerdos verbales. Incómodo con un solo caballo. Con varios caballos, criaderos o cuidados compartidos surgen lagunas, citas olvidadas y malentendidos.",
      items: [
        "¿Cuándo era la fecha de vacunación?",
        "¿Quién pagó al herrador?",
        "¿Qué yegua hay que revisar hoy?",
        "¿Ha leído el entrenador las instrucciones de la semana pasada?",
        "¿Guardé realmente ese documento con fotos?",
        "¿Sigue vigente el plan de alimentación que hay en la cuadra?",
      ],
    },
    what: {
      title: "¿Qué es una app de gestión de caballos?",
      lead: "Una app de gestión de caballos es, en esencia, un expediente digital por caballo. Sin notas dispersas, sino un único lugar para salud, entrenamiento, alimentación, documentos, planificación, recordatorios, costes, fotos, vídeos y acceso compartido. Todos los que rodean al caballo consultan la misma información actualizada.",
      targetGroupsTitle: "¿Para quién es una app de gestión de caballos?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Propietario particular",
          body: "Un caballo, un expediente — salud, planificación e historial en tu bolsillo.",
        },
        {
          icon: "Users",
          title: "Propietario de varios caballos",
          body: "Perfiles separados, planificación independiente, lista de tareas compartida para todo el equipo.",
        },
        {
          icon: "Building2",
          title: "Cuadra de pensión y picadero",
          body: "Acceso del propietario, instrucciones de cuidado, agenda compartida y tareas.",
        },
        {
          icon: "Baby",
          title: "Criadero",
          body: "Ciclo de la yegua, gestación, datos del semental, árbol genealógico y desarrollo del potro.",
        },
        {
          icon: "Target",
          title: "Entrenadores",
          body: "Visión por caballo, registro de sesiones, establecimiento de objetivos, análisis de vídeos.",
        },
        {
          icon: "ClipboardList",
          title: "Profesionales",
          body: "Herrador, dentista, fisioterapeuta o veterinario — trabajan desde el mismo expediente.",
        },
      ],
    },
    criteria: {
      title: "¿Qué debe cumplir una buena app de gestión de caballos?",
      lead: "Una app no solo debe ser atractiva — tiene que funcionar de forma práctica a diario. Cinco elementos imprescindibles a la hora de elegir en 2026.",
      items: [
        {
          icon: "FileText",
          title: "Expediente por caballo",
          body: "Datos, edad, raza, información del pasaporte, propietario, cuadra, fotos y documentos — todo vinculado a un único perfil equino.",
        },
        {
          icon: "Heart",
          title: "Salud y cuidados",
          body: "Vacunas, desparasitaciones, herrador, dentista, veterinario, tratamientos, medicación y recordatorios automáticos antes de la fecha de vencimiento.",
        },
        {
          icon: "Activity",
          title: "Entrenamiento y progreso",
          body: "Registro de entrenamientos, notas, vídeos, resultados de competición, objetivos y progreso por disciplina o por caballo.",
        },
        {
          icon: "Apple",
          title: "Alimentación y manejo",
          body: "Planes de alimentación, suplementos, forraje, peso, condición corporal y la rutina diaria que la cuadra debe conocer.",
        },
        {
          icon: "Share2",
          title: "Compartir con otros",
          body: "Acceso para propietario, cuidador, entrenador, encargado de cuadra o profesional — con gestión de permisos adaptada a cada rol.",
        },
        {
          icon: "Calendar",
          title: "Planificación y recordatorios",
          body: "Una agenda compartida con tareas, recordatorios automáticos y confirmaciones para que nada se escape.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs otras apps de gestión de caballos.",
      lead: "El mercado hispanohablante cuenta con diversas alternativas. Cada una tiene sus puntos fuertes. Comparamos las funciones más solicitadas de forma honesta y basándonos en información públicamente disponible.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Empezar gratis",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Varios caballos",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Historial de salud",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Entrenamiento y progreso",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Alimentación y suplementos",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Planificación y recordatorios",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Documentos por caballo",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Compartir con equipo y permisos",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Módulo criadero (completo)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Ciclo de la yegua",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Planificación gestación + ecografías",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Desarrollo del potro",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integración de profesionales",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Informes EquiCoach",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Apto para propietarios",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Apto para criaderos",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Apto para cuadra/picadero",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Comparativa basada en funciones públicamente disponibles en enero de 2026. Las alternativas son también buenas herramientas; EquiSight está diseñado para combinar todos los módulos en una sola app.",
    },
    why: {
      title: "Por qué EquiSight es diferente.",
      lead: "Un diario registra. EquiSight combina gestión equina, entrenamiento, alimentación, salud, competiciones, profesionales y criadero en una sola app moderna — y va un paso más allá con información y análisis.",
      points: [
        {
          icon: "Heart",
          title: "Una sola app para toda la vida del caballo",
          body: "Desde potro hasta caballo de deporte, yegua de cría o caballo de retiro. El expediente crece con tu caballo — nada se pierde por el camino.",
        },
        {
          icon: "Sparkles",
          title: "No solo datos, también patrones",
          body: "EquiCoach combina desarrollo, problemas recurrentes, entrenamiento y alimentación — para que detectes señales a tiempo, no avisos sueltos.",
        },
        {
          icon: "Share2",
          title: "Diseñado para la colaboración",
          body: "Propietario, encargado de cuadra, entrenador, herrador y otros profesionales trabajan desde el mismo expediente equino — con los permisos que corresponden a su rol.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Nicho · criadero",
      title: "Gestión equina para criaderos.",
      lead: "Muchas alternativas mencionan el criadero en una sola línea. EquiSight desarrolló un módulo de criadero completo — porque el criador rara vez es el usuario habitual de una app genérica, pero necesita más planificación que nadie.",
      items: [
        "Seguimiento diario del ciclo de la yegua",
        "Fecha de inseminación + datos del semental",
        "Control de gestación con ecografías",
        "Fecha prevista de parto + alertas",
        "Desarrollo del potro mes a mes",
        "Árbol genealógico y pedigree",
        "Notas por yegua",
        "Resumen de todas las yeguas gestantes",
      ],
      ctaLabel: "Ver el módulo de criadero",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Nicho · cuadra y picadero",
      title: "Gestión de caballos para múltiples animales y cuadras de pensión.",
      lead: "Con varios caballos, la clave no es tanto los datos sino la comunicación. Cada propietario tiene sus propias preferencias, rutinas, acuerdos de alimentación y puntos médicos a tener en cuenta. Cada empleado debe poder acceder a esa información sin tener que buscarla.",
      cards: [
        {
          t: "Caballos por propietario",
          d: "Cada propietario solo ve su caballo o sus caballos.",
        },
        {
          t: "Instrucciones de cuidado",
          d: "Visibles por caballo para el personal de la cuadra.",
        },
        {
          t: "Agenda compartida",
          d: "Herrador, veterinario y competiciones en una sola vista.",
        },
        {
          t: "Lista de tareas",
          d: "Asignadas a empleados, con confirmación.",
        },
        {
          t: "Acceso del propietario",
          d: "Los clientes ven su caballo en su propia app.",
        },
        {
          t: "Contactos de emergencia",
          d: "Siempre localizables en situaciones de urgencia en la cuadra.",
        },
      ],
      ctaLabel: "Ver el módulo para picaderos",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "De WhatsApp, Excel y pizarra a EquiSight.",
      lead: "En concreto: así cambia tu gestión diaria de caballos.",
      rows: [
        {
          before: "Grupos de WhatsApp",
          after: "Notas estructuradas por caballo",
        },
        {
          before: "Hojas de Excel",
          after: "Expediente equino en tiempo real con historial",
        },
        {
          before: "Pizarra en la cuadra",
          after: "Planificación compartida en tu móvil",
        },
        {
          before: "Fotos sueltas en la cámara",
          after: "Multimedia vinculada a tu caballo",
        },
        {
          before: "Acuerdos verbales",
          after: "Tareas y recordatorios con confirmación",
        },
        {
          before: "Pasaporte en papel extraviado",
          after: "Documentos siempre a mano",
        },
      ],
    },
    helper: {
      title: "¿Qué app de gestión de caballos es la adecuada para ti?",
      lead: "Responde estas 5 preguntas y recibirás una recomendación honesta — incluso si no siempre es EquiSight.",
      questions: [
        {
          id: "horses",
          q: "¿Tienes uno o varios caballos?",
          options: [
            {
              label: "Un solo caballo",
              score: 1,
            },
            {
              label: "2–5 caballos",
              score: 2,
            },
            {
              label: "Más de 5 caballos",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "¿Gestionas caballos de clientes o terceros?",
          options: [
            {
              label: "No, solo mis propios caballos",
              score: 0,
            },
            {
              label: "A veces — para familiares o conocidos",
              score: 1,
            },
            {
              label: "Sí, de forma profesional (cuadra / picadero)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "¿Quieres hacer seguimiento del criadero y la gestación?",
          options: [
            {
              label: "No es relevante",
              score: 0,
            },
            {
              label: "A veces — cría ocasional",
              score: 1,
            },
            {
              label: "Sí, soy (o seré) criador",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "¿Trabajas con entrenador, cuidador o profesional?",
          options: [
            {
              label: "No, lo hago todo yo",
              score: 0,
            },
            {
              label: "Sí, con 1 persona",
              score: 1,
            },
            {
              label: "Sí, con varias personas",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "¿Solo quieres registrar o también obtener análisis e información?",
          options: [
            {
              label: "Solo registrar",
              score: 1,
            },
            {
              label: "Registrar + planificación",
              score: 2,
            },
            {
              label: "Registrar + planificación + análisis",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Un diario sencillo es suficiente — y crece contigo.",
          body: "Para un solo caballo sin cuidados compartidos, cualquier app de gestión equina es adecuada. EquiSight empieza gratis con 1 caballo, así que no hay ningún riesgo. Si más adelante quieres añadir más caballos, un entrenador o un criadero, todo está ya incluido.",
          cta: "Empieza gratis con 1 caballo",
        },
        mid: {
          title: "EquiSight se adapta bien a tu situación.",
          body: "Tienes varias necesidades (varios caballos, colaboración o análisis). La mayoría de las alternativas cubren 1-2 módulos; EquiSight los combina todos en una sola app, sin necesidad de conectar herramientas independientes.",
          cta: "Descubre qué puede hacer EquiSight",
        },
        high: {
          title: "EquiSight es la opción más lógica.",
          body: "Tu situación combina varios caballos, colaboración, criadero y/o análisis. Es exactamente donde EquiSight marca la diferencia — sin herramientas dispersas, sino un único expediente equino para todo y para todos los que rodean al caballo.",
          cta: "Empieza gratis con EquiSight",
        },
      },
    },
    faqTitle: "Preguntas frecuentes sobre apps de gestión de caballos",
    faq: [
      {
        q: "¿Cuál es la mejor app de gestión de caballos?",
        a: "La mejor app de gestión de caballos depende de tu situación. Para un simple diario, varias apps son adecuadas. Si quieres combinar salud, entrenamiento, alimentación, documentos, criadero, planificación y colaboración, EquiSight está diseñado como solución completa donde todo converge en un único expediente.",
      },
      {
        q: "¿Puedo gestionar varios caballos en una sola app?",
        a: "Sí. Una buena app de gestión de caballos debe admitir varios caballos, incluyendo propietarios, cuidadores, rutinas, documentos, citas y recordatorios por caballo. EquiSight está diseñado desde el primer momento para esto — los caballos son expedientes individuales, no filas en una lista.",
      },
      {
        q: "¿Es EquiSight también adecuado para criaderos?",
        a: "Sí. EquiSight puede configurarse con funciones de criadero como ciclo de la yegua, fecha de inseminación, control de gestación, datos del semental, árbol genealógico, fecha prevista de parto y desarrollo del potro. Este es precisamente el área en la que la mayoría de las apps de la competencia no ofrecen o apenas ofrecen soluciones.",
      },
      {
        q: "¿Puedo compartir datos con mi entrenador o herrador?",
        a: "Sí. El objetivo de EquiSight es que la información relevante pueda compartirse de forma segura con las personas que rodean al caballo — entrenador, herrador, dentista, veterinario, fisioterapeuta, cuidador o propietario. Cada persona recibe únicamente los permisos necesarios para su rol.",
      },
      {
        q: "¿Por qué no usar simplemente WhatsApp o Excel?",
        a: "WhatsApp y Excel funcionan mientras todo sea sencillo. En cuanto tienes varios caballos, citas, documentos, tratamientos, propietarios o datos de criadero, se vuelven propensos a errores: la información se dispersa, buscar algo lleva tiempo y los acuerdos verbales desaparecen. Una app de gestión de caballos reúne todo por caballo, con recordatorios automáticos.",
      },
      {
        q: "¿Cuánto cuesta EquiSight?",
        a: "Puedes empezar gratis con 1 caballo. Si quieres gestionar varios caballos, activar el módulo de criadero o dar acceso a profesionales, existen planes Premium asequibles. Consulta las opciones actuales en la página de precios.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Software de cría de caballos: comparativa completa 2026",
      description: "Compara software de cría para caballos: ciclo de la yegua, gestación, elección de semental y potros. Descubre por qué EquiSight es la app de cría más completa.",
      keywords: [
        "software de cría de caballos",
        "app ciclo de la yegua",
        "app gestación yegua",
        "app registro de potros",
        "app libro genealógico caballo",
        "planificación de cubrición caballos",
        "app elección de semental",
      ],
    },
    hero: {
      eyebrow: "Guía de elección · software de cría",
      breadcrumbLabel: "Software de cría",
      title: "Software de cría de caballos: la comparativa completa para 2026.",
      intro: "Una yegua de cría merece más que una app genérica de gestión equina. Compara las funciones de cría de las herramientas más conocidas, descubre en qué debes fijarte de verdad y elige conscientemente el software que se adapta a tu yeguada, grande o pequeña.",
      pills: [
        {
          icon: "Baby",
          label: "Ciclo de la yegua",
        },
        {
          icon: "Heart",
          label: "Control de gestación",
        },
        {
          icon: "Sparkles",
          label: "Desarrollo del potro",
        },
        {
          icon: "FileText",
          label: "Libro genealógico",
        },
      ],
      ctas: [
        {
          label: "Empieza gratis con el módulo de cría",
          href: "#start",
          primary: true,
        },
        {
          label: "Ver tabla comparativa",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Por qué una app genérica de gestión equina no es suficiente para la cría.",
      lead: "La mayoría de las apps ecuestres están diseñadas para un único caballo de deporte o recreo. La cría tiene un ritmo completamente diferente: celo, inseminación, control de gestación, ecografías, calendario de potros, árbol genealógico y venta. Un Excel se descontrola tras 2 temporadas, y con varias yeguas pierdes el hilo.",
      items: [
        "¿Cuándo fue el último ciclo de Bonita?",
        "¿Qué semental está previsto para la cubrición de la próxima temporada?",
        "¿Ya está programada la ecografía del día 21?",
        "¿Qué potros de 2024 ya se han vendido?",
        "¿Dónde está el diagrama genealógico hasta el abuelo materno?",
        "¿Dónde están las muestras de ADN y los datos del pasaporte?",
      ],
    },
    what: {
      title: "¿Qué es el software de cría de caballos?",
      lead: "El software de cría es un expediente especializado por yegua y semental, combinado con un calendario de temporada de cría, planificación de gestación, registro de potros y visualización del árbol genealógico. No es un diario equino general, sino una herramienta que comprende el ciclo reproductivo: desde el primer celo hasta el destete.",
      targetGroupsTitle: "¿Para qué tipo de criador está pensado el software de cría?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Criador aficionado (1-3 yeguas)",
          body: "Una o dos cubriciones al año: control sin malabares de Excel.",
        },
        {
          icon: "Building2",
          title: "Yeguada pequeña (4-10 yeguas)",
          body: "Un plan de temporada de cría con ciclo, inseminación, controles de gestación y expediente del potro.",
        },
        {
          icon: "Users",
          title: "Yeguada profesional (10+)",
          body: "Varios empleados, elección de semental por yegua, venta y marketing.",
        },
        {
          icon: "Target",
          title: "Propietario de semental",
          body: "Historial de pedidos, estadísticas de semen y agenda por semental.",
        },
        {
          icon: "Heart",
          title: "Transferencia de embriones",
          body: "Yegua donante + receptora como expediente vinculado, calendario de TE.",
        },
        {
          icon: "ClipboardList",
          title: "Registro en libro genealógico",
          body: "Muestras de ADN, documentos del pasaporte y datos genealógicos.",
        },
      ],
    },
    criteria: {
      title: "¿Qué debe cumplir un buen software de cría?",
      lead: "No todas las 'funciones de cría' en una app equina son iguales. Cinco áreas clave donde los criadores pierden mucho tiempo y donde el software marca una diferencia real.",
      items: [
        {
          icon: "Calendar",
          title: "Ciclo de la yegua y celo",
          body: "Registro diario, predicción de ovulación, seguimiento por ciclo y recordatorios automáticos.",
        },
        {
          icon: "Heart",
          title: "Inseminación y control de gestación",
          body: "Fechas de cubrición e inseminación, datos del semental, ecografía de 14 días, de 21 días, de 60 días y determinación del sexo.",
        },
        {
          icon: "Baby",
          title: "Desarrollo del potro",
          body: "Datos de nacimiento, gráfica de peso, calendario de desparasitación, momento del destete, registro del pasaporte.",
        },
        {
          icon: "FileText",
          title: "Árbol genealógico y documentación",
          body: "Visualización del árbol genealógico hasta 4-5 generaciones, ADN, números de pasaporte y estado en el libro genealógico.",
        },
        {
          icon: "Target",
          title: "Elección de semental y emparejamiento",
          body: "Filtrado por disciplina, líneas, datos del semental e historial de éxitos, no solo lo que promueve el propietario del semental.",
        },
        {
          icon: "Share2",
          title: "Colaboración con veterinario/inseminador",
          body: "Ecografías, muestras y estados compartidos directamente con la clínica que trabaja con tus yeguas.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs otros software de cría.",
      lead: "Los resultados de búsqueda en español para software de cría suelen mostrar apps ecuestres genéricas que mencionan la cría en una sola frase. Comparamos honestamente qué herramientas tienen realmente un flujo de cría completo.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Inicio gratuito",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Registro del ciclo de la yegua",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Fecha de inseminación + semental",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ecografías y control de gestación",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Fecha prevista de nacimiento del potro",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Expediente del potro (peso/crecimiento)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Árbol genealógico hasta 4-5 generaciones",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Registro de ADN y pasaporte",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Elección de semental / emparejamiento",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "TE / transferencia de embriones",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Vista general de varias yeguas",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Móvil (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Compartir con veterinario",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrado con expediente general",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Venta y marketing de potros",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Comparativa basada en funciones disponibles públicamente en enero de 2026. EquineGenie destaca en cría, pero menos en móvil y gestión equina general. EquiSight combina ambas.",
    },
    why: {
      title: "Por qué EquiSight atiende a los criadores de forma diferente.",
      lead: "Muchos criadores trabajan con un software de cría independiente y una app de gestión equina separada. EquiSight combina ambas, sin necesidad de cambiar de app ni introducir datos dos veces.",
      points: [
        {
          icon: "Heart",
          title: "La yegua de cría sigue siendo un caballo",
          body: "La yegua de cría tiene un expediente de temporada de cría y un expediente equino normal: salud, vacunas, herrador. Una sola app, todos los módulos.",
        },
        {
          icon: "Sparkles",
          title: "Predictivo, no reactivo",
          body: "Predicción del ciclo, recordatorios de hitos de gestación y calendario de potros, generados automáticamente a partir de tus datos.",
        },
        {
          icon: "Share2",
          title: "Todos los implicados en la cría",
          body: "Inseminador, propietario del semental, veterinario, comprador, libro genealógico: todos con acceso y los permisos adecuados.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Por disciplina · del ciclo al destete",
      title: "Qué contiene un expediente de cría en EquiSight.",
      lead: "Por cada yegua obtienes un expediente de cría completo, vinculado a su expediente equino regular.",
      items: [
        "Registro diario del ciclo con predicción",
        "Inseminación/cubrición + datos del semental",
        "Línea de tiempo de ecografías (14/21/60 días + sexo)",
        "Hitos de gestación con recordatorios automáticos",
        "Fecha prevista de nacimiento y preparación",
        "Expediente del potro desde el nacimiento",
        "Árbol genealógico hasta abuelos con navegación por clic",
        "Muestra de ADN, pasaporte, estado en libro genealógico",
        "Pipeline de venta con lista de interesados",
        "Historial de elección de semental por yegua",
      ],
      ctaLabel: "Ver el módulo de cría",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Para toda la yeguada",
      title: "Visión general de varias yeguas y sementales.",
      lead: "Cuando crías más de 2-3 yeguas, tener una visión global de todos los ciclos y gestaciones se vuelve fundamental.",
      cards: [
        {
          t: "Panel de ciclos",
          d: "Todas las yeguas en paralelo, con la fase del ciclo y la próxima acción.",
        },
        {
          t: "Pipeline de gestación",
          d: "¿En qué hito de gestación se encuentra cada yegua?",
        },
        {
          t: "Calendario de potros",
          d: "Nacimientos previstos por mes, con la logística coordinada.",
        },
        {
          t: "Cartera de sementales",
          d: "Sementales propios o inseminadores habituales con historial de pedidos.",
        },
        {
          t: "Gráfico genealógico",
          d: "Análisis de antecesores a lo largo de varias generaciones y líneas.",
        },
        {
          t: "Panel de ventas",
          d: "Qué potros están vendidos, reservados o todavía disponibles.",
        },
      ],
    },
    beforeAfter: {
      title: "De Excel y agenda a EquiSight de cría.",
      lead: "En concreto: así cambia tu temporada de cría.",
      rows: [
        {
          before: "Ciclo en nota suelta",
          after: "Registro diario con predicción",
        },
        {
          before: "Ecografías por WhatsApp al inseminador",
          after: "Expediente compartido con fotos",
        },
        {
          before: "Fecha de gestación en la agenda",
          after: "Recordatorios automáticos de hitos",
        },
        {
          before: "Pasaporte del potro en el cajón",
          after: "Documento vinculado al perfil del potro",
        },
        {
          before: "Árbol genealógico en papel",
          after: "Árbol genealógico interactivo hasta 4-5 generaciones",
        },
        {
          before: "Anuncio de venta en Marktplaats",
          after: "Pipeline de venta con lista de interesados",
        },
      ],
    },
    helper: {
      title: "¿Qué software de cría es el adecuado para ti?",
      lead: "5 preguntas para saber si necesitas una app de cría completa o si con una herramienta para aficionados es suficiente.",
      questions: [
        {
          id: "mares",
          q: "¿Cuántas yeguas de cría gestionas?",
          options: [
            {
              label: "1 yegua",
              score: 1,
            },
            {
              label: "2-5 yeguas",
              score: 2,
            },
            {
              label: "Más de 5 yeguas",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "¿Con qué frecuencia crías al año?",
          options: [
            {
              label: "De forma esporádica (cada varios años)",
              score: 0,
            },
            {
              label: "1-2 cubriciones cada año",
              score: 2,
            },
            {
              label: "3 o más cubriciones cada año",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "¿Cómo inseminas o cubres?",
          options: [
            {
              label: "Monta natural",
              score: 1,
            },
            {
              label: "IA con semen fresco/refrigerado",
              score: 2,
            },
            {
              label: "TE o semen congelado",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "¿Colaboras con veterinario/inseminador?",
          options: [
            {
              label: "Una sola persona fija",
              score: 1,
            },
            {
              label: "Varias clínicas",
              score: 2,
            },
            {
              label: "Red internacional",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "¿Qué usas actualmente para el seguimiento?",
          options: [
            {
              label: "Excel o papel",
              score: 1,
            },
            {
              label: "App genérica de gestión equina",
              score: 2,
            },
            {
              label: "Nada estructurado",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Una herramienta para aficionados o Excel es suficiente, aunque EquiSight sigue siendo útil.",
          body: "Para 1 yegua con monta natural cada varios años, un módulo de cría avanzado es excesivo. EquiSight es gratuito para empezar y puedes activar el módulo de cría solo para el año en que cubres, sin ninguna obligación de actualización.",
          cta: "Empieza gratis",
        },
        mid: {
          title: "EquiSight de cría es la herramienta adecuada.",
          body: "Tienes varias yeguas o varios métodos de cría, para lo que las apps ecuestres genéricas no están diseñadas. EquiSight combina cría y cuidado general para que no tengas que cambiar entre dos herramientas.",
          cta: "Ver el módulo de cría",
        },
        high: {
          title: "EquiSight está hecho para tu yeguada.",
          body: "Varias yeguas, TE o semen congelado, equipo internacional: la mayoría de las herramientas se quedan cortas aquí. EquiSight escala hasta el nivel de yeguada profesional sin necesidad de acumular licencias adicionales.",
          cta: "Habla con nosotros sobre un plan de Yeguada",
        },
      },
    },
    faqTitle: "Preguntas frecuentes sobre software de cría",
    faq: [
      {
        q: "¿Cuál es el mejor software de cría de caballos?",
        a: "Para 1 yegua sin métodos de cría complejos, muchas herramientas son suficientes. A partir de 2-3 yeguas, con el uso de IA o TE, o trabajando con veterinario y libro genealógico, un módulo de cría completo se vuelve imprescindible. EquiSight combina la cría con la gestión equina general en una sola app, para que no tengas que cambiar de herramienta.",
      },
      {
        q: "¿Qué funciones de cría necesito realmente?",
        a: "Como mínimo: registro del ciclo, datos de inseminación/cubrición, hitos de control de gestación y expediente del potro. Opcional pero muy potente: visualización del árbol genealógico, archivo de elección de semental, ADN/pasaporte y pipeline de venta.",
      },
      {
        q: "¿Puede EquiSight predecir el ciclo de una yegua?",
        a: "Sí. EquiSight utiliza los datos de ciclos anteriores para mostrar la ovulación prevista, de modo que puedas planificar la inseminación o la cubrición en el momento adecuado, sin tener que adivinar día a día.",
      },
      {
        q: "¿Funciona EquiSight también para la transferencia de embriones?",
        a: "Sí. La yegua donante y la receptora tienen expedientes vinculados, calendario de TE e hitos compartidos con la clínica. Así no pierdes el hilo temporal en el complejo proceso de TE.",
      },
      {
        q: "¿Puedo importar mis datos de cría existentes?",
        a: "Puedes introducir ciclos, cubriciones y datos de potros manualmente o en lote mediante CSV. En yeguadas activas te ayudamos con una migración puntual si tienes datos de varias temporadas.",
      },
      {
        q: "¿Cómo comparto el expediente con mi veterinario o inseminador?",
        a: "Cada persona recibe acceso con un rol: veterinario, inseminador, propietario de semental o responsable del libro genealógico. Cada uno ve únicamente la información necesaria para su rol, sin necesidad de acceso completo.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Software para hípica: comparativa completa y guía de elección 2026",
      description: "Compara software para hípicas en clases, jinetes, caballos y administración. Descubre qué app se adapta a tu centro ecuestre o pensión equina.",
      keywords: [
        "software para hípica",
        "app de gestión de cuadra",
        "software de administración para hípica",
        "planificación de clases hípica",
        "software para pensión equina",
        "administración de jinetes",
        "administración de caballos hípica",
      ],
    },
    hero: {
      eyebrow: "Guía de elección · software para hípica",
      breadcrumbLabel: "Software para hípica",
      title: "Software para hípica: la guía completa para centros ecuestres y pensiones equinas.",
      intro: "Planificación de clases, administración de jinetes, gestión de caballos, facturación y comunicación — un buen software para hípica lo une todo. Compara las opciones más conocidas y descubre cuál se adapta a tu cuadra o centro ecuestre.",
      pills: [
        {
          icon: "Calendar",
          label: "Planificación de clases",
        },
        {
          icon: "Users",
          label: "Jinetes y clientes",
        },
        {
          icon: "Heart",
          label: "Cuidado equino",
        },
        {
          icon: "CreditCard",
          label: "Facturación",
        },
      ],
      ctas: [
        {
          label: "Solicita una demo",
          href: "#start",
          primary: true,
        },
        {
          label: "Ver tabla comparativa",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Por qué tener herramientas dispersas ralentiza tu hípica.",
      lead: "La mayoría de los centros ecuestres funcionan con un sistema fragmentado: la planificación de clases en una pizarra, el registro de jinetes en Excel, la facturación en otra herramienta, el cuidado de caballos en WhatsApp y el contacto con propietarios mediante mensajes personales. En una semana ajetreada, esto genera reservas duplicadas, facturas olvidadas o caballos sin asignación de jinete.",
      items: [
        "¿Quién está ahora en clase con Jasmijn?",
        "¿Qué jinete no ha pagado las clases de marzo?",
        "¿Qué caballo no puede trabajar esta semana?",
        "¿Cuáles son los contactos de emergencia de los alumnos?",
        "¿Ha recibido ya el propietario de Stardust la factura del herrador?",
        "¿Qué caballo está en qué box?",
      ],
    },
    what: {
      title: "¿Qué es el software para hípica?",
      lead: "El software para hípica combina la planificación de clases, la administración de jinetes, la gestión de caballos, la facturación y la comunicación en una sola herramienta. Sin acrobacias en Excel ni caos en WhatsApp, sino un único lugar donde trabaja la hípica y donde propietarios y jinetes pueden consultar todo.",
      targetGroupsTitle: "¿Para qué tipo de empresa está pensado el software para hípica?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Hípica pequeña (1-15 caballos)",
          body: "Principalmente planificación de clases y pagos — administración sin complicaciones.",
        },
        {
          icon: "Users",
          title: "Hípica mediana (15-40 caballos)",
          body: "Varios instructores, planificación de clases + horario de caballos + administración de jinetes.",
        },
        {
          icon: "ClipboardList",
          title: "Centro ecuestre y pensión grande (40+)",
          body: "Operación completa incluyendo facturación, planificación de alimentación y herrador.",
        },
        {
          icon: "Heart",
          title: "Pensión equina",
          body: "Portal del propietario, instrucciones de cuidado individuales, agenda compartida.",
        },
        {
          icon: "Target",
          title: "Cuadra de entrenamiento de salto",
          body: "Planificación de competiciones, entrenamiento por caballo, contacto con clientes.",
        },
        {
          icon: "FileText",
          title: "Empresarios hípicos",
          body: "Combinación de clases + pensión + clínicas + compraventa — todo desde un único sistema.",
        },
      ],
    },
    criteria: {
      title: "¿Qué debe cumplir un buen software para hípica?",
      lead: "Una app atractiva no vale nada si tus empleados no quieren usarla. Cinco criterios prácticos que marcan la diferencia entre el éxito y la frustración.",
      items: [
        {
          icon: "Calendar",
          title: "Planificación de clases en varios niveles",
          body: "Iniciación/avanzado, doma/salto, asignación de caballos y agendas de instructores — todo visible a la vez.",
        },
        {
          icon: "Users",
          title: "Administración de jinetes",
          body: "Perfiles, nivel, suscripción, tarjeta de clases y vinculación de familiares para jinetes jóvenes.",
        },
        {
          icon: "Heart",
          title: "Horario de caballos",
          body: "Con qué frecuencia trabaja cada caballo, con períodos de descanso, lesiones y recuperación.",
        },
        {
          icon: "CreditCard",
          title: "Facturación y suscripciones",
          body: "Suscripciones mensuales, tarjetas de clases, clases sueltas y domiciliación bancaria automática.",
        },
        {
          icon: "Share2",
          title: "Portal del propietario (pensión equina)",
          body: "Los propietarios ven a su caballo en su propia app — agenda, gastos, herrador y notas sin necesidad de llamar.",
        },
        {
          icon: "Bell",
          title: "Comunicación y recordatorios",
          body: "Recordatorios automáticos de clases, avisos de pago, anuncios del herrador — sin usar el móvil para mensajes.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs otros software para hípica.",
      lead: "Muchas herramientas para hípicas son potentes en planificación de clases o facturación, pero raramente en cuidado equino y comunicación con propietarios a la vez. Los comparamos con total honestidad.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Inicio gratuito / período de prueba",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Planificación de clases",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Varios instructores",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Administración de jinetes",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Horario de caballos",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Cuidado equino (vacunas/herrador)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Tarjeta de clases / suscripción",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Pagos en línea",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Facturación automática",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Portal del propietario (pensión)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integración herrador/veterinario",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Recordatorios por WhatsApp/SMS",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Móvil (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Planificación de competiciones",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Apto para pensión equina",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Comparativa basada en funcionalidades públicamente disponibles en enero de 2026. Stalmanager destaca en administración; EquiSight se diferencia por su flujo de pensión equina + cuidado de caballos + portal del propietario.",
    },
    why: {
      title: "Por qué EquiSight es diferente para centros ecuestres y pensiones equinas.",
      lead: "EquiSight va más allá de un simple planificador de clases. Entendemos una hípica como una operación completa: caballos, personas, comunicación y dinero — todo interdependiente.",
      points: [
        {
          icon: "Heart",
          title: "El caballo en el centro, no la agenda",
          body: "Cada caballo tiene su propio expediente. Participación en clases, salud, herrador y competiciones en una sola línea de tiempo — no en 3 herramientas separadas.",
        },
        {
          icon: "Share2",
          title: "Propietarios informados sin llamadas",
          body: "Los propietarios de la pensión tienen su propia vista: gastos, planificación, fotos y notas — ahorra entre 5 y 10 llamadas telefónicas a la semana.",
        },
        {
          icon: "Bell",
          title: "Comunicación automática",
          body: "Recordatorio de clase, aviso de vacuna, factura — automáticamente, por app/email/SMS. Sin más grupos de WhatsApp.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Para la pensión equina",
      title: "Lo que una pensión equina obtiene con EquiSight.",
      lead: "Las pensiones equinas tienen desafíos únicos que el software convencional para hípicas no resuelve.",
      cards: [
        {
          t: "Portal del propietario",
          d: "Cada propietario ve únicamente su(s) caballo(s), agenda y gastos.",
        },
        {
          t: "Instrucciones de cuidado por caballo",
          d: "Alimentación, forraje, suplementos, programa de mantas — visible para el personal de cuadra.",
        },
        {
          t: "Agenda compartida",
          d: "Herrador, veterinario y visitas del propietario en una sola vista.",
        },
        {
          t: "Gastos de consumo por caballo",
          d: "Cama, pienso y forraje repercutidos por propietario.",
        },
        {
          t: "Contactos de emergencia del caballo",
          d: "Propietario, veterinario y herrador siempre localizables para la cuadra.",
        },
        {
          t: "Gestión de vacaciones",
          d: "¿Qué caballos salen a pasto, están en descanso o en rehabilitación?",
        },
      ],
    },
    beforeAfter: {
      title: "De pizarra y Excel a EquiSight.",
      lead: "En concreto: así cambia una semana de trabajo en la hípica.",
      rows: [
        {
          before: "Pizarra con la planificación de clases",
          after: "Planificación en tiempo real por instructor",
        },
        {
          before: "Excel con jinetes y notas de clases",
          after: "CRM de clientes con historial de clases",
        },
        {
          before: "WhatsApp a los propietarios",
          after: "Portal del propietario para su caballo",
        },
        {
          before: "Domiciliación mensual manual",
          after: "Facturación automática + iDEAL",
        },
        {
          before: "Cuidado del caballo en un tablón de papel",
          after: "Instrucciones de cuidado por caballo, compartidas",
        },
        {
          before: "Cita verbal con el herrador",
          after: "Planificación del herrador con confirmaciones",
        },
      ],
    },
    helper: {
      title: "¿Qué software para hípica es el adecuado para ti?",
      lead: "5 preguntas para saber si EquiSight es la plataforma correcta para tu centro ecuestre o pensión equina.",
      questions: [
        {
          id: "size",
          q: "¿Cuántos caballos tienes en tu negocio?",
          options: [
            {
              label: "Menos de 10",
              score: 1,
            },
            {
              label: "10-30",
              score: 2,
            },
            {
              label: "Más de 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "¿Cuál es tu actividad principal?",
          options: [
            {
              label: "Principalmente impartir clases",
              score: 1,
            },
            {
              label: "Pensión equina (caballos en pensión)",
              score: 3,
            },
            {
              label: "Combinación de clases + pensión",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "¿Con cuántos instructores trabajas?",
          options: [
            {
              label: "Solo yo",
              score: 1,
            },
            {
              label: "2-3 instructores",
              score: 2,
            },
            {
              label: "4 o más",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "¿Cómo gestionas actualmente tu facturación?",
          options: [
            {
              label: "Manualmente (Word/Excel)",
              score: 3,
            },
            {
              label: "Programa de contabilidad independiente",
              score: 2,
            },
            {
              label: "Integrado en la herramienta de clases",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "¿Cómo te comunicas con los propietarios?",
          options: [
            {
              label: "En persona / WhatsApp",
              score: 3,
            },
            {
              label: "Email + WhatsApp",
              score: 2,
            },
            {
              label: "Portal del propietario en la herramienta",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Una herramienta básica o Excel puede ser suficiente por ahora — pero EquiSight crece contigo.",
          body: "Para un pequeño centro de clases con un solo instructor y poca pensión, un paquete completo no es imprescindible de inmediato. EquiSight comienza gratis y crece con tu hípica — sin el dolor de una migración en unos años.",
          cta: "Empieza gratis",
        },
        mid: {
          title: "EquiSight es una mejora lógica para tu hípica.",
          body: "Varios instructores, una combinación de clases y pensión, o facturación que ahora está desconectada — EquiSight lo unifica en un solo flujo de trabajo. El portal del propietario, en particular, reduce mucho la comunicación improvisada.",
          cta: "Solicita una demo",
        },
        high: {
          title: "EquiSight está diseñado para tu escala.",
          body: "Pensión equina + clases + varios instructores es exactamente donde EquiSight se distingue de las herramientas convencionales. El portal del propietario y la integración de cuidado equino ahorran horas de administración y comunicación cada semana.",
          cta: "Programa una demo para tu cuadra",
        },
      },
    },
    faqTitle: "Preguntas frecuentes sobre software para hípica",
    faq: [
      {
        q: "¿Cuál es el mejor software para hípica?",
        a: "Para la planificación pura de clases hay varias buenas opciones. En el momento en que necesitas una pensión equina, varios instructores o seguimiento del cuidado de caballos, EquiSight se convierte en la solución completa — sin malabarismos entre herramientas, todo en un solo lugar.",
      },
      {
        q: "¿Puedo importar clientes y clases existentes?",
        a: "Sí. Los datos de clientes y los horarios de clases se pueden importar mediante CSV. Ayudamos a los centros ecuestres activos con una migración única para que no tengas que introducir manualmente a 200 jinetes.",
      },
      {
        q: "¿Funciona también para una pensión equina sin clases?",
        a: "Sí. El modo pensión equina desactiva las clases y se centra en el portal del propietario, alimentación y cuidados, planificación del herrador y repercusión de gastos por caballo.",
      },
      {
        q: "¿Pueden los jinetes inscribirse y pagar por su cuenta?",
        a: "Sí. Los jinetes pueden ver desde su propia cuenta qué clases están disponibles, inscribirse, pagar las clases con iDEAL y comprar tarjetas de clases.",
      },
      {
        q: "¿Qué hay de la privacidad de los datos del caballo y del propietario?",
        a: "Cada persona tiene un rol (propietario, jinete, instructor, empleado). Según el rol, solo ves lo que necesitas. Los propietarios ven únicamente su caballo; los jinetes, solo sus propias clases.",
      },
      {
        q: "¿Puede EquiSight conectarse con mi software de contabilidad?",
        a: "Sí, están disponibles integraciones con Exact, Moneybird y e-Boekhouden. Las facturas se transfieren entonces automáticamente a tu contabilidad.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "App de entrenador para caballos: comparativa y guía de elección para coaches 2026",
      description: "Compara apps de entrenador para caballo y jinete: diario de entrenamiento, vídeo, objetivos, análisis de protocolos y gestión de clientes. Encuentra la herramienta ideal para coaches.",
      keywords: [
        "app entrenador caballos",
        "app instructor ecuestre",
        "app entrenamiento caballos",
        "app coaching jinete",
        "diario de entrenamiento caballo",
        "analizar protocolo dressage",
        "software entrenador ecuestre",
      ],
    },
    hero: {
      eyebrow: "Guía de elección · software de entrenador",
      breadcrumbLabel: "App de entrenador",
      title: "App de entrenador para caballos: guía completa para instructores y coaches.",
      intro: "Un entrenador o instructor hace malabares con combinaciones, clases, vídeos, objetivos y competiciones. Compara las mejores apps de entrenador para el mundo ecuestre y elige la plataforma que seguirá creciendo contigo en 2026.",
      pills: [
        {
          icon: "Target",
          label: "Objetivos y planificación",
        },
        {
          icon: "Video",
          label: "Análisis de vídeo",
        },
        {
          icon: "TrendingUp",
          label: "Progreso",
        },
        {
          icon: "Users",
          label: "Clientes/combinaciones",
        },
      ],
      ctas: [
        {
          label: "Empieza gratis como entrenador",
          href: "#start",
          primary: true,
        },
        {
          label: "Ver tabla comparativa",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Por qué el coaching por WhatsApp frena a los entrenadores.",
      lead: "La mayoría de los entrenadores trabajan con herramientas dispersas: WhatsApp para comunicarse, un cuaderno para las clases, YouTube o WeTransfer para los vídeos y Excel para los resultados de competición. Con 5 jinetes funciona. Con 20 jinetes se pierde información, se olvidan objetivos y se pierde el control sobre el progreso individual.",
      items: [
        "¿Cuál es el objetivo de Ana para esta temporada?",
        "¿Qué vídeo le envié el mes pasado a Carlos?",
        "¿Ha visto Laura el análisis del protocolo de su última competición?",
        "¿Qué combinación entrena cuántas veces por semana?",
        "¿Ha leído el propietario de Stardust mis instrucciones de entrenamiento?",
        "¿Cuándo fue la última vez que di feedback sobre el impulso fluctuante?",
      ],
    },
    what: {
      title: "¿Qué es una app de entrenador para caballo y jinete?",
      lead: "Una app de entrenador combina un CRM de coaching (combinaciones, clases, objetivos), un diario de entrenamiento por caballo, feedback en vídeo, planificación de competiciones y análisis de protocolos. Sin más WhatsApp/YouTube/Excel sueltos, sino una única plataforma donde entrenador y jinete trabajan juntos.",
      targetGroupsTitle: "¿Para qué tipo de entrenador está pensado?",
      targetGroups: [
        {
          icon: "Target",
          title: "Instructor de dressage",
          body: "Escanear protocolos, vincular comentarios del jurado a objetivos de entrenamiento, ver el progreso.",
        },
        {
          icon: "Activity",
          title: "Entrenador de salto",
          body: "Planificación de recorridos, feedback por vuelta, gestión de alturas por caballo.",
        },
        {
          icon: "Award",
          title: "Coach de eventing",
          body: "Tres disciplinas, tres planificaciones — todas visibles a la vez.",
        },
        {
          icon: "TrendingUp",
          title: "Coach de rendimiento (deporte)",
          body: "Seguimiento de EPI, competiciones, objetivos — para deportistas de alto nivel y sus equipos.",
        },
        {
          icon: "Users",
          title: "Instructor de picadero",
          body: "Clases grupales + coaching individual en una sola app.",
        },
        {
          icon: "Heart",
          title: "Coach recreativo",
          body: "Terapia hípica, principiantes, propietarios con un solo caballo.",
        },
      ],
    },
    criteria: {
      title: "¿Qué debe cumplir una buena app de entrenador?",
      lead: "Entrenar es trabajo humano, pero la herramienta adecuada te hace un 30-50% más eficiente y ayuda a los jinetes a mejorar también entre clases.",
      items: [
        {
          icon: "Users",
          title: "Gestión de combinaciones",
          body: "Caballo + jinete como una unidad, con nivel, objetivos, progreso e historial.",
        },
        {
          icon: "ClipboardList",
          title: "Notas de clase y objetivos",
          body: "Una nota por clase con puntos de enfoque, vinculada a objetivos a largo plazo.",
        },
        {
          icon: "Video",
          title: "Feedback en vídeo",
          body: "Sube vídeo, marca momentos, añade feedback hablado o escrito.",
        },
        {
          icon: "Target",
          title: "Análisis de competición y protocolo",
          body: "Escanea protocolos (KNHS/FEI), ve puntuaciones por ejercicio, comentarios del jurado y tendencias.",
        },
        {
          icon: "Calendar",
          title: "Planificación y bonos de clases",
          body: "Agenda, pagos, suscripciones y recordatorios automáticos.",
        },
        {
          icon: "Share2",
          title: "Comunicación con el jinete",
          body: "El jinete ve su propia página con clases, vídeos, objetivos y feedback.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs otras apps de entrenador.",
      lead: "Algunas herramientas para entrenadores se centran en sustituir WhatsApp, otras en el análisis de protocolos. EquiSight combina ambas cosas con un verdadero expediente del caballo — para que el jinete mejore también entre clases.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Empezar gratis",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Gestión de combinaciones",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Notas de clase y feedback",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Objetivos a largo plazo",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Subida de vídeo + feedback",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Escaneo de protocolo KNHS/FEI",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Índice de Rendimiento)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Calendario de competiciones",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Portal del jinete",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Bono de clases / suscripción",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Pagos online",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Expediente integrado del caballo",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Herrador/veterinario visibles",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Para instructor Y jinete",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Varios caballos por jinete",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Comparativa basada en funciones públicamente disponibles en enero de 2026. EquiSight es único en análisis de protocolos + EPI y lo combina con la gestión general del caballo.",
    },
    why: {
      title: "Por qué EquiSight ofrece una experiencia de entrenador diferente.",
      lead: "La mayoría de las herramientas para entrenadores terminan donde acaba la clase. EquiSight sigue funcionando — en el expediente del caballo, en el análisis de competiciones, en la colaboración con el veterinario y el propietario.",
      points: [
        {
          icon: "TrendingUp",
          title: "Escaneo de protocolo → objetivo de entrenamiento",
          body: "Escanea un protocolo KNHS y ve de inmediato qué ejercicios necesitan atención. Los objetivos surgen automáticamente.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach potencia tu ojo clínico",
          body: "Los datos de varias clases, competiciones y protocolos revelan patrones que no podrías retener en la memoria.",
        },
        {
          icon: "Share2",
          title: "Integrado con el caballo",
          body: "El entrenador ve el historial de vacunas, herrador y lesiones del caballo — sin planificar entrenamientos durante la recuperación.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Para dressage y salto",
      title: "Qué contiene un expediente de coaching en EquiSight.",
      lead: "Cada combinación tiene un flujo de coaching que lo reúne todo — sin perder más cosas en WhatsApp.",
      items: [
        "Notas de clase con puntos de enfoque por sesión",
        "Objetivos a largo plazo + hitos",
        "Subida de vídeo con comentarios por código de tiempo",
        "Escaneo de protocolo KNHS/FEI con puntuaciones",
        "Comentarios del jurado vinculados al entrenamiento",
        "Resultados de competición y tendencia EPI",
        "Contacto con el cliente e historial de clases",
        "Bono de clases / suscripción / facturas",
        "Gráfico de progreso por disciplina",
        "Acceso compartido con el propietario del caballo",
      ],
      ctaLabel: "Ver el módulo de entrenador",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "De WhatsApp + YouTube a EquiSight Trainer.",
      lead: "En concreto: así cambia tu flujo de trabajo como coach.",
      rows: [
        {
          before: "WhatsApp con enlaces de vídeo sueltos",
          after: "Vídeo con feedback por código de tiempo en el expediente",
        },
        {
          before: "Cuaderno por jinete",
          after: "Registro de coaching con objetivos e historial",
        },
        {
          before: "Excel con puntuaciones de competición",
          after: "Gráfico EPI + análisis de protocolo",
        },
        {
          before: "Objetivos verbales",
          after: "Hitos con indicador de progreso",
        },
        {
          before: "Herramienta de facturación aparte",
          after: "Clases + iDEAL + suscripción en la app",
        },
        {
          before: "Correo al propietario sobre el progreso",
          after: "El propietario hace seguimiento en su propia vista",
        },
      ],
    },
    helper: {
      title: "¿Qué app de entrenador encaja contigo?",
      lead: "5 preguntas para ver si una herramienta de coaching especializada aporta valor a tu práctica.",
      questions: [
        {
          id: "clients",
          q: "¿Cuántas combinaciones activas entrenas?",
          options: [
            {
              label: "Menos de 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Más de 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "¿Cuál es tu disciplina principal?",
          options: [
            {
              label: "Dressage",
              score: 3,
            },
            {
              label: "Salto",
              score: 2,
            },
            {
              label: "Recreativo / diverso",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "¿Usas vídeo en tu coaching?",
          options: [
            {
              label: "Raramente",
              score: 0,
            },
            {
              label: "A veces (de forma manual)",
              score: 2,
            },
            {
              label: "Con frecuencia — de manera estructurada",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "¿Entrenas a jinetes de competición?",
          options: [
            {
              label: "No, recreativo",
              score: 0,
            },
            {
              label: "Alguna competición",
              score: 2,
            },
            {
              label: "Muchas — las tarjetas de salida son clave",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "¿Quieres medir tu coaching?",
          options: [
            {
              label: "No, la intuición es suficiente",
              score: 0,
            },
            {
              label: "Sí, pero no tengo tiempo",
              score: 2,
            },
            {
              label: "Sí — coaching basado en datos",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Una herramienta sencilla o incluso WhatsApp es suficiente — por ahora.",
          body: "Para menos de 5 jinetes sin mucho vídeo ni competiciones, una app de coaching es excesiva. EquiSight comienza gratis, así que puedes probarlo cuando tu práctica crezca.",
          cta: "Empieza gratis",
        },
        mid: {
          title: "EquiSight Trainer te hace estructuralmente más eficiente.",
          body: "Con 5-15 combinaciones pierdes horas cada mes en WhatsApp y vídeos sueltos. EquiSight lo centraliza todo, escanea protocolos automáticamente y permite que los jinetes revisen su feedback en cualquier momento.",
          cta: "Probar el módulo Trainer",
        },
        high: {
          title: "EquiSight está construido para tu escala de coaching.",
          body: "Muchos jinetes, vídeo, competiciones y coaching basado en datos: esto es exactamente donde EquiSight destaca. EPI + escaneo de protocolo + expediente del caballo te dan una ventaja que los competidores no tienen.",
          cta: "Solicita una demo para tu práctica de coaching",
        },
      },
    },
    faqTitle: "Preguntas frecuentes sobre apps de entrenador",
    faq: [
      {
        q: "¿Cuál es la mejor app de entrenador para caballo y jinete?",
        a: "Para la comunicación pura, muchas herramientas son suficientes (incluso WhatsApp). Para objetivos, análisis de vídeo, escaneo de protocolos, seguimiento de competiciones y gestión de clientes en una sola herramienta, EquiSight es la solución más completa — sobre todo porque también registra al caballo en sí, no solo la combinación.",
      },
      {
        q: "¿Puede EquiSight leer automáticamente los protocolos de competición?",
        a: "Sí. Sube un protocolo KNHS o FEI y EquiSight extrae las puntuaciones por ejercicio, los comentarios del jurado y los vincula a la combinación. Puedes ver las tendencias a lo largo de varias competiciones.",
      },
      {
        q: "¿Qué es el EPI (Equestrian Performance Index)?",
        a: "El EPI es una puntuación de EquiSight que convierte varios resultados de competición en un índice de rendimiento comparable. Así puedes ver el progreso real a través de diferentes categorías y jurados.",
      },
      {
        q: "¿Pueden los jinetes reservar y pagar mis clases ellos mismos?",
        a: "Sí. Los jinetes inician sesión, ven los horarios disponibles, compran bonos de clases y pagan a través de iDEAL. Tú decides qué quieres ofrecer y lo apruebas.",
      },
      {
        q: "¿Funciona también para un instructor que trabaja en un picadero?",
        a: "Sí. Puedes trabajar como entrenador autónomo con tus propios clientes sin necesidad de vincular una cuenta de picadero. Los clientes te pagan directamente.",
      },
      {
        q: "¿Puedo migrar mis vídeos y notas existentes?",
        a: "Los vídeos se pueden subir por combinación o mediante una herramienta de subida por lotes. Las notas se importan mediante CSV. Ayudamos a los entrenadores activos con una migración única.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Guías y ayudas para elegir software de gestión equina | EquiSight",
      description: "Todas las guías de EquiSight en un solo lugar: comparaciones de software de gestión equina, cría, picadero y entrenador, más ayudas de elección para 2026.",
      keywords: [
        "guías de software equino",
        "ayuda para elegir gestión equina",
        "comparar software de cría equina",
        "guía de software para picadero",
        "comparación de apps para entrenadores",
      ],
    },
    hub: {
      eyebrow: "Hub · guías",
      breadcrumbLabel: "Guías",
      title: "Cuatro guías completas para elegir el software equino adecuado.",
      intro: "Una ayuda de elección detallada para cada perfil: tablas comparativas, criterios, ejemplos y un cuestionario interactivo. Haz clic en la guía que se adapte a tu situación o explora primero los artículos en profundidad de cada bloque.",
      stats: {
        guides: "4 ayudas de elección",
        articles: "15 artículos en profundidad",
        fair: "Comparación imparcial",
      },
      readMoreCta: "Lee la guía completa",
      relatedHeading: "Artículos en profundidad",
      articlesCountSingular: "{{count}} artículo en profundidad",
      articlesCountPlural: "{{count}} artículos en profundidad",
      articlesCountAria: "Número de artículos del bloque",
      lastUpdatedPrefix: "Actualizado",
      lastUpdatedAria: "Fecha de la última actualización de este bloque",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Ayuda para elegir una app de gestión equina",
        blurb: "Compara las apps de gestión equina más conocidas y descubre cuál encaja con el propietario, la cuadra o la yeguada. Incluye una tabla comparativa imparcial y una ayuda de 5 preguntas.",
        audience: "Para propietarios, responsables de cuadra y todos los aficionados al mundo del caballo que buscan claridad.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Comparación de software de cría equina",
        blurb: "Del ciclo de la yegua al desarrollo del potro: descubre qué software de cría funciona realmente según tu número de yeguas, método de cría y requisitos de stud book.",
        audience: "Para criadores (aficionados y profesionales), haras y propietarios de sementales.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Ayuda para elegir software de picadero",
        blurb: "Planificación de clases, administración de jinetes, portal de propietarios y facturación, todo en una sola herramienta. Compara las opciones para picaderos y cuadras de pensión en 2026.",
        audience: "Para picaderos, cuadras de pensión y centros hípicos.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Ayuda para elegir una app de entrenador",
        blurb: "CRM de coaching, videofeedback, análisis de protocolos KNHS y objetivos por binomio. ¿Qué app de entrenador se adapta mejor a tu práctica de coaching?",
        audience: "Para instructores, entrenadores y coaches.",
      },
    ],
    closing: {
      eyebrow: "Por qué estas guías",
      title: "Comparación honesta, no solo de precios.",
      body1: "Muchas «páginas de comparación» son publicidad encubierta. Nuestras guías presentan funciones, público objetivo y competidores uno al lado del otro, como lo haría una fuente de conocimiento independiente. EquiSight aparece de forma natural como solución completa, pero también leerás con honestidad en qué aspectos otras apps son más fuertes.",
      body2: "Los artículos en profundidad de cada guía responden a las preguntas concretas que surgen tras la elección: «Cuándo hacer la primera ecografía tras la inseminación», «Cómo automatizo la facturación del picadero», «Cómo analizo un protocolo de competición». Sin relleno de marketing, solo práctica real.",
    },
    hubName: "Guías EquiSight",
  },
  ui: {
    sectionEyebrows: {
      pains: "Por qué esto duele",
      basics: "Conceptos básicos",
      criteria: "¿Qué lo hace bueno?",
      comparison: "Comparación honesta",
      why: "La diferencia",
      beforeAfter: "Del caos al control",
      helper: "5 preguntas",
    },
    table: {
      feature: "Función",
      today: "Hoy",
      withEquisight: "Con EquiSight",
    },
    helper: {
      questionLabel: "Pregunta {{current}} de {{total}}",
      answerPrompt: "Responde la {{count}} pregunta restante para ver una recomendación.",
      answerPromptPlural: "Responde las {{count}} preguntas restantes para ver una recomendación.",
      resultEyebrow: "Tu resultado",
    },
    targetGroupsFallback: "¿Para quién es esto?",
    faqTitleFallback: "Preguntas frecuentes",
  },
};

export default CORNERSTONES;
